import styled, { css } from 'styled-components'

import closeIcon from 'assets/images/blue-close-icon.svg'
import menuIcon from 'assets/images/burger-menu-icon.svg'

import { Color, MediaBreakpoint } from 'root-constants'

type TProps = {
  $isMenuVisible: boolean
}

const baseButtonStyles = css`
  background-color: transparent;
  cursor: pointer;
  border: none;
  outline: none;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
`

export const StyledBurgerMenu = {
  Wrapper: styled.div`
    grid-area: menu;

    position: absolute;
    top: 0;
    bottom: 0;
    right: 20px;

    display: flex;
    align-items: center;
  `,
  Burger: styled.button`
    ${baseButtonStyles};
    width: 22px;
    height: 22px;
    background-image: url(${menuIcon});
  `,
  Backdrop: styled.div<TProps>`
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    opacity: ${({ $isMenuVisible }) => ($isMenuVisible ? '1' : '0')};
    visibility: ${({ $isMenuVisible }) =>
      $isMenuVisible ? 'visible' : 'hidden'};
    pointer-events: ${({ $isMenuVisible }) =>
      $isMenuVisible ? 'default' : 'none'};
    transition: all 0.25s;
  `,
  Menu: styled.nav<TProps>`
    position: fixed;
    top: 0;
    bottom: 0;
    inset-inline-end: 0;

    width: 350px;
    height: var(--full-height, 100vh);
    display: flex;
    flex-direction: column;
    background-color: ${Color.WHITE};
    padding: 80px 24px;
    transition: transform 0.25s;
    transform: ${({ $isMenuVisible }) =>
      $isMenuVisible ? 'translateX(0)' : 'translateX(100%)'};

    @media (max-width: ${MediaBreakpoint.MAX_PHONE}px) {
      width: 100%;
    }

    a {
      font-size: 18px;
      font-weight: 500;
      line-height: 18px;
      color: ${Color.INK_BASE};
      margin-bottom: 23px;
    }
  `,
  MenuCloseButton: styled.button`
    ${baseButtonStyles};
    width: 32px;
    height: 32px;
    background-image: url(${closeIcon});
    margin-left: auto;
  `,
  Header: styled.div`
    position: absolute;
    inset: 16px 24px auto 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 20px;
    font-weight: 700;
    line-height: 23px;
    color: ${Color.INK_DARKEST};
  `,
}
